import { MEDIA_KIND, MEDIA_PATH_SEGMENTS } from '../../constants/media'

export function getMediaKind(mediaPath, idAuto) {
  if (!mediaPath || !idAuto) {
    return null
  }

  switch (true) {
    case mediaPath.includes(MEDIA_PATH_SEGMENTS.INCOMING):
      return MEDIA_KIND.CLOTH

    case mediaPath.includes(idAuto):
      return MEDIA_KIND.PROPRIETARY

    case !mediaPath.includes():
      return MEDIA_KIND.COMPATIBLE

    default:
      return null
  }
}
